(ns frontend.view.components.timeline.entry.default-item
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [potpuri.core :refer [fn->]]
   [common.audit-ops :as audit-ops]
   [common.localization :as loc]
   [common.roles :as roles]
   [frontend.utils :as fu]
   [common.dates :as d :include-macros true]))

(defn icon
  [op]
  (let [[icon-class font-awesome-class _] (audit-ops/audit-ops op)]
    [:div
     {:class-name (fu/cs "timeline-item-badge-container-badge"
                         (when icon-class
                           (str "timeline-item-badge-container-badge--" icon-class)))}
     [:i
      {:class-name (or font-awesome-class
                       "")}]]))

(def tx-time (some-fn (fn-> :audit/ts js/Date.) :db/txInstant))

(defn title-generator
  [entry]
  (-> entry
      :audit/op
      loc/tr))

(defn body-generator [_])

(defn timestamp-generator
  ([entry]
   (timestamp-generator nil entry))
  ([appender entry]
   (let [time-str (-> entry
                      tx-time
                      (d/format {:pattern (loc/tr :timeline/date-format)}))
         account-name (-> entry
                          :audit/account
                          :account/first-name)
         role (-> entry
                  :audit/role)
         role-str (when (roles/is-guest-role? role)
                    (str " (" (loc/tr :timeline/guest) ")"))
         account-str (str account-name role-str)]
     [:p
      [:small.timeline-item-card-timestamp
       [:i.fal.fa-clock]
       (loc/tr :timeline/timestamp
           (seq [time-str
                 account-str]))
       (when-not (nil? appender)
         (appender entry))]])))

(defn timeline-item-view-template
  [{:keys [click-handler id icon-div title timestamp body]}]
  [:li.timeline-item
   {:on-click #(when click-handler (click-handler))
    :class    (when click-handler "pointer")
    :key      (str "timeline-item-view_" id "-" (rand-int 1000))}
   [:div.table
    [:div.table-row
     [:div.timeline-item-badge-container
      icon-div]
     [:div.timeline-item-card
      [:div.timeline-item-card-header
       [:h4.timeline-item-card-header-title title]
       timestamp]
      (when body
        [:div.timeline-item-body
         body])]]]])

(defn timeline-item-view
  ([entry]
   (timeline-item-view entry title-generator body-generator timestamp-generator nil))
  ([entry title-gen]
   (timeline-item-view entry title-gen body-generator timestamp-generator nil))
  ([entry title-gen body-gen]
   (timeline-item-view entry title-gen body-gen timestamp-generator nil))
  ([entry title-gen body-gen timestamp-gen]
   (timeline-item-view entry title-gen body-gen timestamp-gen nil))
  ([entry title-gen body-gen timestamp-gen click-handler]
   [timeline-item-view-template
    {:click-handler click-handler
     :id            (:db/id entry)
     :icon-div      (icon (:audit/op entry))
     :title         (title-gen entry)
     :timestamp     (timestamp-gen entry)
     :body          (body-gen entry)}]))

(defmethod te/timeline-entry-view :default
  [{entry :entry}]
  [timeline-item-view entry])
